// mds-dojo — dijit/_DialogMixin — FAITHFUL port of references/dijit/_DialogMixin.js.
// AMD → ESM + declare from the faithful runtime. Functions useful to Dialog and
// TooltipDialog (execute/onExecute/onCancel/_onSubmit/_getFocusItems).
import declare from '../dojo/_base/declare-runtime';
import a11y from './a11y';

export default declare('dijit._DialogMixin', null, {
  // summary:
  //		This provides functions useful to Dialog and TooltipDialog

  // actionBarTemplate: String
  //		HTML snippet to show the action bar (gray bar with OK/cancel buttons).
  //		Blank by default, but used by ConfirmDialog/ConfirmTooltipDialog subclasses.
  actionBarTemplate: '',

  execute: function (/*Object*/ /*===== formContents =====*/) {
    // summary:
    //		Callback when the user hits the submit button.
    //		Override this method to handle Dialog execution.
  },

  onCancel: function () {
    // summary:
    //		Called when user has pressed the Dialog's cancel button, to notify container.
  },

  onExecute: function () {
    // summary:
    //		Called when user has pressed the dialog's OK button, to notify container.
  },

  _onSubmit: function (this: any) {
    // summary:
    //		Callback when user hits submit button
    this.onExecute();	// notify container that we are about to execute
    this.execute(this.get('value'));
  },

  _getFocusItems: function (this: any) {
    // summary:
    //		Finds focusable items in dialog,
    //		and sets this._firstFocusItem and this._lastFocusItem

    var elems = a11y._getTabNavigable(this.domNode);
    this._firstFocusItem = elems.lowest || elems.first || this.closeButtonNode || this.domNode;
    this._lastFocusItem = elems.last || elems.highest || this._firstFocusItem;
  }
});
